'use client';
import React from 'react';

import { SessionContext } from '@benzinga/session-context';
import { QuotesManager, QuotesManagerEvent, Security, TickerDetail } from '@benzinga/quotes-manager';
import Hooks from '@benzinga/hooks';

export const useTickerDetails = (symbol: Security): TickerDetail | undefined => {
  const session = React.useContext(SessionContext);
  const quotesManager = session.getManager(QuotesManager);
  const [quote, setQuote] = React.useState<TickerDetail | undefined>(
    () => quotesManager.getTickerDetailsCache(symbol) as unknown as TickerDetail,
  );

  React.useEffect(() => {
    quotesManager.getTickerDetails([symbol]) as unknown as TickerDetail;
  }, [quotesManager, symbol]);

  Hooks.useSubscriber(quotesManager, (event: QuotesManagerEvent) => {
    switch (event.type) {
      case 'get_ticker_details':
        if (event.result?.[0]?.symbol === symbol) {
          setQuote(event.result[0]);
        }
    }
  });
  return quote;
};
